import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Config } from 'src/app/config';

@Injectable()
export class CategoryService {
  constructor(private http: HttpClient, private config: Config) { }

  getList() {
      return this.http.get<any[]>(this.config.getBaseUrl()+`/api/Categories`);
  }

  getTopicList(id: string) {
      return this.http.get<any[]>(this.config.getBaseUrl()+`/api/Categories/${id}/Topics`);
  }

  update(entityId: string, entity: any) {
      return this.http.put(this.config.getBaseUrl()+`/api/Categories/${entityId}`, entity);
  }

  get(id: string) {
    return this.http.get(this.config.getBaseUrl()+`/api/Categories/${id}`);
  }

  delete(id: string) {
    return this.http.delete(this.config.getBaseUrl()+`/api/Categories/${id}`);
  }

  create(entity: any) {
    return this.http.post(this.config.getBaseUrl()+`/api/Categories`, entity);
  }
}
